import React, { useEffect, useState } from "react";
import { storyblokEditable } from "@storyblok/react";
import { ButtonModel } from "../../core/Models/ButtonModel";
import Button from "../../core/Button/Button";
import { ArticleModel } from "../Article/ArticleModel";
import { ImageModel } from "../../core/Models/ImageModel";
import { themeService } from "../../core/NotificationStripNav/ThemeService";
import { Theme } from "../../core/Models/CustomSiteConfigModel";

import "./RelatedArticle.css";
import Utils from "../../core/Utils/Utils";

interface ArticleRef {
  content: { body: Array<ArticleModel>; image: ImageModel };
  uuid: string;
  full_slug: string;
}

const RelatedArticle: React.FC<{ blok: ArticleRef }> = ({ blok }) => {
  const [theme, setTheme] = useState<Theme | null>(themeService.getTheme());

  useEffect(() => {
    const unsubscribe = themeService.subscribe(setTheme);
    return () => unsubscribe();
  }, []);

  if (!blok.content?.body || !blok.content?.body[0]) {
    return null;
  }
  const content = blok.content.body[0];
  const button: ButtonModel = {
    link: { cached_url: blok.full_slug, linktype: "story" },
    label: "READ NOW",
    borderColor: "#000000",
    color: "#FFFFFF",
    textColor: "#000000",
    hoverColor: "#FFFFFF",
  };

  return (
    <div
      {...storyblokEditable(content)}
      className={`related-articles-comp`}
      style={{
        backgroundColor: theme?.containerColor,
        color: theme?.textColor,
      }}
    >
      <div className="article-title">{content.title}</div>
      <div className="related-content-immage">
        {blok.content?.image?.filename && (
          <img
            src={Utils.getCacheUrl(blok.content?.image.filename)}
            alt=""
            onError={(e) =>
              Utils.handleImageError(e, blok.content.image.filename)
            }
          />
        )}
      </div>
      <div className="related-content-action">
        <Button blok={button}></Button>
      </div>
    </div>
  );
};

export default RelatedArticle;
